import $ from '@ali/tarzan-zepto';
import IScroll from 'iscroll';
import moment from 'moment';
import util from '../../../lib/util.js';
import BaseUI from '../../../component/baseui/index';
import tpl from './tpl.html';
import pop from './list.html';

require('./style.scss');
require('./list.scss');

let app = null;

const TAP = util.isPC() ? 'click' : 'tap';


// 数据转换
function convert(list) {
  let con = [];
  const bundles = list.bundles || [];
  const items = list.items || [];
  bundles.map((item) => {
    con = con.concat(item.items);
    return item;
  });
  con = con.concat(items);
  console.log(con);
  return con;
}


function __show($node, cb) {
  // 向下滑,隐藏知识浮层
  setTimeout(() => {
    $node.find('.layer-body').addClass('slideUp');
    setTimeout(() => {
      cb();
    }, 350);
  }, 10);
}

function __hide($node) {
  $node.find('.J_Layer').removeClass('slideUp');
  setTimeout(() => {
    $node.remove();
  }, 320);
}
function __bindEvent($node) {
  $node.find('.layer-mask').on(TAP, () => {
    __hide($node);
  });
  $node.find('.layer-close').on(TAP, () => {
    __hide($node);
  });
}


// // pop up
function popUp(list) {
  list.title = app.util.lang.get('packageOrder')(list.sortIndex, list.sortLength);
  const $node = $(pop.render(list));
  $('.m-alicare').append($node);
  $node.find('.layer-mask').animate({
    opacity: 1,
  }, 300);
  $node.find('.layer-mask').on('touchmove', (ev) => {
    ev.preventDefault();
  });
  __show($node, () => {
    __bindEvent($node);
  });
}

// 初始化横向滚动
function initScroll(data, $node) {
  const num = data.list.shipments.length;
  const prev = $node.find('.prev');
  const next = $node.find('.next');
  const order = $node.find('.m-chatpanel-option-button');
  const pics = $node.find('.package-items');


  if (num === 1) {
    next.hide();
  }

  $node.find('.J_Packagelist').css({
    width: 274,
  });

  $node.find('.J_Package').css({
    width: 218,
  });

  $node.find('.J_Scroller').css({ width: 230 * num });

  const scroller = new IScroll($node.find('.J_Packagelist')[0], {
    scrollX: true,
    scrollY: false,
    momentum: false,
    snap: 'div.J_Package',
  });

  scroller.on('scrollEnd', () => {
    const len = scroller.pages.length;
    const index = scroller.currentPage.pageX;
    if (index === 0) {
      prev.hide();
      next.show();
    } else if (index === (len - 1)) {
      next.hide();
      prev.show();
    } else {
      prev.show();
      next.show();
    }
  });
  // 事件绑定
  next.on(TAP, () => {
    scroller.next();
  });
  prev.on(TAP, () => {
    scroller.prev();
  });
  order.on(TAP, (ev) => {
    const $target = $(ev.currentTarget);
    const i = $target.attr('data-index');
    const item = data.list.shipments[i - 1];

    const param = {
      address: data.list.address_shipping,
      index: i,
      number: data.list.number,
      status: item.status,
      status_history: item.status_history ? item.status_history : [],
      date: `${item.date_label ? item.date_label : ''}`,
      commentId: data.list.commentId,
      action: data.list.action,
    };
    // if ($target.hasClass('disabled')) return;
    // order.addClass('disabled');
    app.appendMessage({
      type: 'express',
      body: param,
    });
  });

  pics.on(TAP, (ev) => {
    const $target = $(ev.currentTarget);
    const i = $target.attr('data-index');
    data.list.shipments[i - 1].sortIndex = i;
    data.list.shipments[i - 1].sortLength = data.list.shipments.length;
    popUp(data.list.shipments[i - 1]);
  });
}


// 对外暴露
export default function orderdetail(data) {
  app = this;

  data.list.shipments.map((item, index) => {
    item.langPackage = app.util.lang.get('packageOrder')(index + 1, data.list.shipments.length);
    item.showList = convert(item);
    item.date_interval_from = moment(item.date_interval_from).format('Do MMM');
    item.date_interval_to = moment(item.date_interval_to).format('Do MMM');
    return item;
  });
  data.list.langTotal = this.util.lang.get('packageDetail')(data.list.number, data.list.shipments.length);
  data.list.langTrack = this.util.lang.get('TRACKING:DETAIL');
  const tem = tpl.render(data.list);
  const param = {
    name: 'orderdetail',
    mid: '11',
    content: tem,
  };

  const $node = $(BaseUI.msg(param));

  setTimeout(() => {
    if (data.list.shipments === 0) return;
    initScroll(data, $node);
    this.view.body.scrollToBottom();
  }, 0);

  return {
    body: $node,
    callback: () => {
    },
  };
}




// WEBPACK FOOTER //
// ./src/app/extension/orderdetail/index.js